'use client';

import { useCallback } from 'react';
import { useGetTreatingV2Query } from 'src/api/redux';
import { getNewExport } from 'src/api';
import { useTableFilterSelections } from '../filters';
import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';

interface TableParams {
  sort?: string;
  sort_id?: string | null;
  sort_field?: string | null;
  order?: string;
  page?: number;
  pageSize?: number;
  q?: string | null;
}

interface UseGetTreatingV2Params {
  provider_id: string;
  tableParams: TableParams;
}

const useGetTreatingV2 = ({ provider_id, tableParams }: UseGetTreatingV2Params) => {
  const { apiFilterFormat, apiVolumeFilterFormat } =
    useTableFilterSelections('treating');

  // Build the data object for the POST body
  const data = {
    ...apiVolumeFilterFormat,
  };

  // Get filter set IDs
  const filterSets = apiFilterFormat;

  const { data: responseData, isLoading, isFetching, error } = useGetTreatingV2Query(
    {
      provider_id,
      tableParams,
      filterSets,
      data,
    },
    {
      skip: !provider_id,
    }
  );

  // Build query params for export (matches original implementation)
  const queryParams = getSearchQueryParamsForAPI(tableParams);
  const filterSetQueryParams = filterSets
    .map(
      (id) => `&${encodeURIComponent('filter_set')}=${encodeURIComponent(String(id))}`
    )
    .join('');
  const fullQueryParams = queryParams + filterSetQueryParams;

  const exportTreating = useCallback(
    async ({ fileFormat, columns, fileName }: {
      fileFormat: string;
      columns: string[];
      fileName: string;
    }) => {
      const url = `https://api.medscout.io/api/v1/entities/v2/entity/${provider_id}/affiliations/treating/${fullQueryParams}`;

      try {
        await getNewExport({
          method: 'POST',
          url,
          fileFormat,
          columns,
          data,
          fileName,
        });
      } catch (error) {
        console.error('Export error:', error);
        throw error;
      }
    },
    [provider_id, fullQueryParams, data]
  );

  return {
    data: responseData,
    isLoading,
    isFetching,
    error,
    exportTreating,
    isValidating: isFetching,
  };
};

export default useGetTreatingV2;
